// extracted by mini-css-extract-plugin
export default {"root":"Text_root__Xl15o"};